import type { LeagueSummary } from "@tnp/contracts";
import ConfirmModal from "../../../../shared/components/ConfirmModal";
import Toast from "../../../../shared/components/Toast";
import { deleteLeague } from "../../shared/services/leagueService";
import { getLeagueFlowTexts } from "../leagueFlowTexts";
import { useState } from "react";
import Button from "../../../../shared/components/Button";
import { useAuth } from "../../../auth/shared/hooks/useAuth";
import { getLeagueTexts } from "../../shared/leagueTexts";
import LeagueDirectory from "../../shared/components/LeagueDirectory";
import LeagueOrganizerAccess from "./LeagueOrganizerAccess";
import LeagueEditor from "./LeagueEditor";
import "../../shared/leagues.css";

export default function LeagueManagementPanel() {
  const { token } = useAuth();
  const t = getLeagueTexts();
  const f = getLeagueFlowTexts();
  const [selection, setSelection] = useState<string | null>(null);
  const [created, setCreated] = useState(false);
  const [revision, setRevision] = useState(0);
  const [target, setTarget] = useState<LeagueSummary | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [toast, setToast] = useState<{ message: string; variant: "success" | "error" } | null>(null);
  async function remove() {
    if (!target || !token || deleting) return;
    setDeleting(true);
    try {
      await deleteLeague(token, target.id, target.revision);
      setTarget(null);
      setRevision(value => value + 1);
      setToast({ message: f.removed, variant: "success" });
    } catch (error) {
      setToast({ message: error instanceof Error ? error.message : f.removeError, variant: "error" });
    } finally { setDeleting(false); }
  }
  return <LeagueOrganizerAccess><section className="league-feature">
    <div className="league-management-header">
      <h2>{selection === "new" && !created ? t.create : t.title}</h2>
      {selection
        ? <Button variant="ghost" onClick={() => { setSelection(null); setCreated(false); setRevision(value => value + 1); }}>{t.back}</Button>
        : <Button onClick={() => { setCreated(false); setSelection("new"); }}>{t.create}</Button>}
    </div>
    {selection
      ? <LeagueEditor key={selection} id={selection === "new" ? undefined : selection} onSaved={() => setCreated(true)} />
      : <LeagueDirectory key={revision} token={token} onEdit={setSelection} onDelete={setTarget} />}
    <ConfirmModal open={Boolean(target)} title={f.removeTitle} message={`${target?.name || ""}. ${f.removeMessage}`} confirmLabel={f.remove} loading={deleting} onConfirm={() => void remove()} onCancel={() => { if (!deleting) setTarget(null); }} />
    {toast && <Toast message={toast.message} variant={toast.variant} onClose={() => setToast(null)} />}
  </section></LeagueOrganizerAccess>;
}
